import { render } from 'react-dom';
import { identifySentry, setupSentry } from './lib/vendor/sentry';
import { initStores } from './storage/stores';

/*
 * Initialize custom pages on load.
 *
 * @remarks
 * WARNING! Any initialization done here might be needed to be placed in the background script and content script as well.
 */
export const onLoad = async (initialComponent: JSX.Element) => {
  setupSentry();
  await initStores();
  // Set deviceUID and accountUID for Sentry events as soon as the storage is ready to get them
  identifySentry();
  render(initialComponent, document.getElementById('root'));
};
